/** @file Emits an axis-aligned filled rectangle in pixels on the white page. */
import type { Sink } from './createSink';
import { emitQuad } from './emitQuad';

const xy = new Float64Array(8);

/** Top-left (x, y), size w x h, all in pixels (y down). */
export function emitRect(sink: Sink, x: number, y: number, w: number, h: number, light: number): void {
  xy[0] = x; xy[1] = y;
  xy[2] = x + w; xy[3] = y;
  xy[4] = x + w; xy[5] = y + h;
  xy[6] = x; xy[7] = y + h;
  emitQuad(sink, xy, light);
}
